import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const Divider = ({
    text = '',
    textColor,
    lineColor,
    lineWidth,
    fontSize = '14px',
    fontWeight = 500,
    letterSpacing = '-0.42px',
    gap = '10px',
    padding = '0 0px',
    sx = {},
    lineSx = {},
    ...props
}) => {
    const theme = useTheme();

    textColor = textColor || theme.palette.figma.white[60];
    lineColor = lineColor || theme.palette.figma.white[0];

    const containerStyles = {
        display: 'flex',
        width: '100%',
        gap: gap,
        padding: padding,
        display: 'flex',
        alignItems: 'center',
        ...sx,
    };

    const textStyles = {
        fontSize: fontSize,
        fontWeight: fontWeight,
        color: textColor,
        letterSpacing: letterSpacing,
        lineHeight: 0,
        whiteSpace: 'nowrap',
        flexShrink: 0,
    };

    const lineStyles = {
        flex: 1,
        height: '1px',
        backgroundColor: lineColor,
        position: 'relative',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            height: '1px',
            backgroundColor: lineColor,
        },
        ...lineSx
    };

    return (
        <Box sx={containerStyles} {...props}>
            {text && <Typography sx={textStyles}>{text}</Typography>}
            <Box sx={lineStyles} />
        </Box>
    );
};

export default Divider;
